import styled from 'styled-components';

import colors from '../../assets/css/colors';

export const Td = styled.td`
	text-align: ${props => props.textAlign ? props.textAlign : 'center'};
	vertical-align: middle;
	padding: 0 5px;
	font-size: 14px;

	&:first-child {
		padding-left: 10px;
	}

	&:last-child {
		padding-right: 10px;
	}
`;

export const Th = styled.th`
	text-align: ${props => props.textAlign ? props.textAlign : 'center'};
	text-transform: uppercase;
	vertical-align: middle;
	color: #FFFFFF;
	height: 50px;
	padding: 5px;
	font-size: 14px;
	font-weight: 700;
	width: ${({ width }) => width || 'auto'};

	&:first-child {
		padding-left: 10px;
	}

	&:last-child {
		padding-right: 10px;
	}
`;

export const Tr = styled.tr`

`;

export const TBody = styled.tbody`
	${Tr} {
		background: #FFFFFF;
		border-bottom: 1px solid ${colors.lightGreen};
	}
`;

export const THead = styled.thead`
	background-color: ${colors.nrlDarkGreen};
`;

export const Table = styled.table`
	width: 100%;
	box-shadow: ${colors.box_shadow};
`;

export default Table;


// WEBPACK FOOTER //
// ./src/components/TableX/index.js